module.exports = __webpack_public_path__ + "components/icon/static/sunrise-414c8a461a5e370d25c4a1618dc00e17.svg";